export default __webpack_public_path__ + "static/media/a016-attention.2ec19c6d.svg";